export default "Afslut jeres Ask & Liv-forløb med en fest på bopladsen eller en fernisering i klassen – vis og fortæl, hvad I har lavet og lært!";